import React from "react"
import { FaSearch } from "react-icons/fa"
import Avatar from "@material-ui/core/Avatar"
import Dropdown from "react-bootstrap/Dropdown"
import firebase from "../../src/components/auth/fire-base.js"
import CountTrial from './wigets/count-trial'
import PaymentSuccessDialog from '../components/dialogs/payment-success-dialog'
import withLocation from "./wigets/withLocation"
import Auth from '../Auth';
import {NotificationManager} from 'react-notifications'
import CircularProgress from '@material-ui/core/CircularProgress';
import { withPrefix } from "gatsby"
import Helmet from "react-helmet"

const auth = new Auth();



class Header extends React.Component {
  constructor(props) {
    super(props)
    this.searchBar = React.createRef()
    this.displayError = React.createRef()
    this.state = {
      currentUser: "",
      pic: "",
      initials: "",
      isShowPaymentSuccessDialog: false,
      user:null,
    }
    this.icon = React.createRef()
    this.closePaymentSuccessDialog = this.closePaymentSuccessDialog.bind(this);
  }

  CustomToggle = React.forwardRef(({ onClick }, ref) => (
    <a
      className="profile-icon"
      href="/"
      ref={ref}
      onClick={e => {
        e.preventDefault()
        onClick(e)
      }}
    >
      <div>
        <Avatar ref={this.icon} src={this.state.pic} style={ this.state.pic ? { display:"block" } : {}}></Avatar>
      </div>
    </a>
  ))

  async componentDidMount(){

    const user = await auth.user();

    this.setState({user: user});
    
    if(user){
      this.setState({ currentUser: user })
      let pic = user.displayPic
      if(pic !== null && pic !== `undefined`&& pic !== undefined) {
        this.setState({pic: pic})
      }
      else {
        this.setState({ pic: ""})
      }
    }else{
      if (window.location.pathname !== "/") {
          window.location.href = "/signin"
      }
    }

    const {success} = this.props.search // If Payment is success, upgrade User to Pro. only pro => true
    if(success){
        const res = await auth.upgradeUserToPro(user);
        if(res.success){
          this.setState({isShowPaymentSuccessDialog: true})
        }else{
          NotificationManager.error('Payment Failed');
        }
    }
  }

  signOut = () => {
    auth.signOut()
  }

  search = async (event) => {
    event.preventDefault()
    if (
      this.searchBar.current.value
        .trim() !== ""
    ) {
      await firebase
        .firestore()
        .collection("pins")
        .doc(this.searchBar.current.value)
        .get()
        .then(doc => {
          if (doc.exists) {
            window.location.href = "/search?pincode=" + this.searchBar.current.value;
            this.displayError.current.hidden = true;
            this.searchBar.current.style.border = "";
          } else {
            this.displayError.current.hidden = false;
            this.searchBar.current.style.border = "3px solid red";
            this.displayError.current.innerHTML = "PIN not found, please try again";
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
    else {
       this.displayError.current.innerHTML = "Please enter a value";
       this.searchBar.current.style.border = "3px solid red";
       this.displayError.current.hidden = false;
    }
  }

  closePaymentSuccessDialog = () =>{
    this.setState({isShowPaymentSuccessDialog: false});
    window.location.href="/profile"
  }


  render() {
    const {user} = this.state;
    return (
     <div>
       <Helmet>
          <script src="https://ajax.aspnetcdn.com/ajax/jQuery/jquery-3.4.1.min.js"></script>
          <script src={withPrefix('invite.js')} type="text/javascript" />
        </Helmet>
       {
         user === null ?
         <div style={{display:'flex', backgroundColor:'white', height:'100vh', justifyContent:'center', alignItems:'center'}}>
            <CircularProgress />
         </div>:
          <div
            className="search-bar-wrapper"
            style={{paddingBottom: 60}}
          >
            {
              (!user.paymentVerified || user.paymeneError) &&
              <div style={{position:'absolute', left:0, top: 68, display:'flex', width:'100vw'}}>
                <CountTrial customer={ user } />
              </div>
            }
            {
              <PaymentSuccessDialog 
                open={this.state.isShowPaymentSuccessDialog}
                handleClose = {this.closePaymentSuccessDialog}
              />
            }
            <form onSubmit={this.search} className = "search-form">
            <div className = "home-search-bar2">
              <div className = "gray-search-btn"
                style={{
                  padding: "8px",
                  float:'left',
                  backgroundColor: "rgb(244,244,244)",
                  borderRadius: "4px 0px 0px 4px",
                }}
              >
                <FaSearch />
              </div>
              <input
                type="text"
                id="search-bar"
                className="search-bar home-search-bar"
                placeholder="  Search by PIN"
                
                ref={this.searchBar}
              ></input>
              <button
                type="submit"
                className="orange-search-btn"
                style={{
                  width: "78px",
                  height: "42px",
                  backgroundColor: "#e8573a",
                  float:'left'
                  
                }}
              >
                <FaSearch icon="search" style={{ color: "fff" }} />
              </button>
              </div>

              <Dropdown className = "profile-avatar" style={{ display: `inline-flex`, marginLeft: `30px` }}>
                <Dropdown.Toggle as={this.CustomToggle} style={{paddingTop: `50px` }}></Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item href="mailto:info@cloudpin.it">Get Help</Dropdown.Item>
                  <Dropdown.Item href="https://cloudpin.zendesk.com/hc/en-us">Leave Feedback</Dropdown.Item>
                  <Dropdown.Item
                    onClick={this.signOut}
                    href={"/"}
                  >
                    Sign Out
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <p style={{ color: "red" }} hidden id="error" ref={this.displayError}>
              </p>
            </form>
          </div>
        }
     </div>
    )
  }
}

export default withLocation(Header)
